import { render, staticRenderFns } from "./Physical.vue?vue&type=template&id=670d7a0d"
import script from "./Physical.vue?vue&type=script&lang=js"
export * from "./Physical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports